import { useContext, useEffect, useState } from "react";
import { LoadingContext } from "../../../composants/loadingContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning, faMapMarkerAlt, faShieldAlt, faExclamationTriangle, faSearch, faMap, faLayerGroup } from "@fortawesome/free-solid-svg-icons";
import { Badge, Empty, Spin, Tooltip } from "antd";
import axiosInstance from "../../../configurations/axiosInstance/AxiosInstance";
import CarteLeafletModal from "../cardmodal/CarteLeafletModal";

export const constantes = {
    pageable: null, last: false, totalElements: 0, totalPages: 0,
    size: 0, number: 0, first: false, numberOfElements: 0, empty: false
};

export default function ListAlert() {
    const [current, setCurrent] = useState("");
    const { loading, setLoading } = useContext(LoadingContext);
    const [pageable, setPageable] = useState(constantes);
    const [url] = useState('public/alert/list');
    const [icon, setIcon] = useState(null);
    const countUrl = 'public/alert/count';
    const [data, setData] = useState([]);
    const [toCarte, setToCarte] = useState([]);
    const [alertRiskTypes, setAlertRiskTypes] = useState([]);
    const [alertTypes, setAlertTypes] = useState([]);

    const fetchAlertCounts = async (items) => {
        try {
            const promises = items.map(value =>
                axiosInstance().get(`${countUrl}?type=${value.id}`)
            );
            const results = await Promise.all(promises);
            const newAlertTypes = results.map((result, index) => ({
                number: result.data,
                value: items[index]
            }));
            setAlertTypes(newAlertTypes);
        } catch (error) { }
    };

    const fetchAllAlertRiskTypes = () => {
        setLoading(true);
        const setCats = [];
        axiosInstance().get("public/alert-type/active-list").then((result) => {
            for (let index = 0; index < result.data.length; index++) {
                const element = result.data[index];
                const category = {
                    id: element.id,
                    icon: `${element?.icon == null ? '' : element.icon}`,
                    title: `${element?.icon == null ? '' : element.icon} ${element.description}`,
                    key: element.code,
                    function: () => { alert(element.id); }
                };
                setCats.push(category);
            }
            setLoading(false);
            setAlertRiskTypes(result.data);
            fetchAlertCounts(setCats);
        }).catch(() => {
            setAlertRiskTypes([]);
            setLoading(false);
        });
    };

    useEffect(() => { fetchAllAlertRiskTypes(); }, []);

    useEffect(() => {
        if (data != []) {
            let uniqueById = data.filter(
                (obj, index, self) =>
                    index === self.findIndex((el) => (el.localities.longitude === obj.localities.longitude) && (el.localities.latitude === obj.localities.latitude))
            );
            setToCarte(uniqueById);
        } else {
            setToCarte(data);
        }
    }, [data]);

    const getData = (value, page = 0) => {
        setLoading(true);
        axiosInstance().get(`${url}?type=${value}&page=${page}`).then((result) => {
            if (result.data.totalElements === 0) {
                setPageable(constantes);
                setData([]);
                setToCarte([]);
            } else {
                setData(result.data.content);
                setPageable({
                    pageable: result.data.pageable, last: result.data.last,
                    totalElements: result.data.totalElements, totalPages: result.data.totalPages,
                    size: result.data.size, number: result.data.number,
                    first: result.data.first, numberOfElements: result.data.numberOfElements,
                    empty: result.data.empty
                });
            }
            setLoading(false);
        }).catch(() => {
            setData([]); setToCarte([]); setPageable(constantes); setLoading(false);
        });
    };

    const fetchAlert = (alertType, page = 0) => {
        if (alertType.value == null) {
            setCurrent(""); setIcon(null);
        } else {
            setCurrent(alertType.value.id); setIcon(alertType.value.icon);
        }
        getData(alertType.value.id, page);
    };

    const changePage = (newPage) => {
        if (current) getData(current, newPage);
    };

    // Status config
    const statusConfig = {
        'ALERT_ACTIVE': { label: 'Active', bg: '#dcfce7', text: '#166534', dot: '#22c55e' },
        'REJECTED': { label: 'Rejeté', bg: '#fee2e2', text: '#991b1b', dot: '#ef4444' },
        'DISMISSED': { label: 'Classé', bg: '#fef3c7', text: '#92400e', dot: '#f59e0b' },
        'RESOLVED': { label: 'Résolu', bg: '#dbeafe', text: '#1e40af', dot: '#3b82f6' },
        'PENDING': { label: 'En attente', bg: '#f3e8ff', text: '#6b21a8', dot: '#a855f7' },
    };

    const getStatus = (status) => statusConfig[status] || { label: status, bg: '#f3f4f6', text: '#374151', dot: '#9ca3af' };

    return (
        <div style={{
            minHeight: '100vh',
            background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 50%, #f1f5f9 100%)',
            padding: '24px 16px',
            paddingTop: '100px',
            fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
        }}>
            <div style={{ maxWidth: '1280px', margin: '0 auto' }}>

                {/* Hero Header */}
                <div style={{
                    background: 'linear-gradient(135deg, #dc2626 0%, #b91c1c 40%, #991b1b 100%)',
                    borderRadius: '24px',
                    padding: '32px 36px',
                    marginBottom: '28px',
                    position: 'relative',
                    overflow: 'hidden',
                    boxShadow: '0 20px 60px rgba(185, 28, 28, 0.25)',
                }}>
                    <div style={{
                        position: 'absolute', top: '-25%', right: '-5%',
                        width: '250px', height: '250px',
                        background: 'rgba(255,255,255,0.06)', borderRadius: '50%',
                    }} />
                    <div style={{
                        position: 'absolute', bottom: '-30%', left: '15%',
                        width: '180px', height: '180px',
                        background: 'rgba(255,255,255,0.04)', borderRadius: '50%',
                    }} />
                    <div style={{ position: 'relative', zIndex: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '16px' }}>
                        <div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '14px', marginBottom: '8px' }}>
                                <div style={{
                                    width: '48px', height: '48px', borderRadius: '14px',
                                    background: 'rgba(255,255,255,0.15)', backdropFilter: 'blur(10px)',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    fontSize: '22px', color: 'white'
                                }}>
                                    <FontAwesomeIcon icon={faShieldAlt} />
                                </div>
                                <h1 style={{ margin: 0, color: 'white', fontSize: '26px', fontWeight: '700', letterSpacing: '-0.5px' }}>
                                    Centre d'Alertes
                                </h1>
                            </div>
                            <p style={{ margin: 0, color: 'rgba(255,255,255,0.8)', fontSize: '14px', marginLeft: '62px' }}>
                                Surveillez et consultez les alertes en temps réel
                            </p>
                        </div>
                        <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                            {data.length > 0 && <CarteLeafletModal items={toCarte} customIcon={icon} />}
                            <div style={{
                                background: 'rgba(255,255,255,0.15)', backdropFilter: 'blur(10px)',
                                borderRadius: '12px', padding: '10px 18px',
                                color: 'white', fontSize: '13px', fontWeight: '600'
                            }}>
                                {pageable.totalElements || 0} alerte(s)
                            </div>
                        </div>
                    </div>
                </div>

                {/* Alert Type Filter Chips */}
                <div style={{
                    background: 'white', borderRadius: '20px',
                    padding: '24px 28px', marginBottom: '24px',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.06), 0 4px 12px rgba(0,0,0,0.04)',
                    border: '1px solid rgba(0,0,0,0.04)',
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px' }}>
                        <FontAwesomeIcon icon={faLayerGroup} style={{ color: '#64748b', fontSize: '14px' }} />
                        <span style={{ fontSize: '14px', fontWeight: '600', color: '#334155' }}>Filtrer par type d'alerte</span>
                    </div>
                    <Spin spinning={loading && alertTypes.length === 0}>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                            {alertTypes.map((alertType) => {
                                const isSelected = current === alertType.value.id;
                                return (
                                    <button
                                        key={alertType.value.key}
                                        onClick={() => fetchAlert(alertType)}
                                        title={alertType.value.title}
                                        style={{
                                            display: 'inline-flex', alignItems: 'center', gap: '10px',
                                            padding: '10px 18px', borderRadius: '12px',
                                            border: isSelected ? '2px solid #dc2626' : '2px solid #e2e8f0',
                                            background: isSelected ? 'linear-gradient(135deg, #fef2f2, #fee2e2)' : '#f8fafc',
                                            color: isSelected ? '#991b1b' : '#475569',
                                            fontSize: '14px', fontWeight: isSelected ? '600' : '500',
                                            cursor: 'pointer',
                                            transition: 'all 0.25s ease',
                                            boxShadow: isSelected ? '0 4px 12px rgba(220, 38, 38, 0.15)' : 'none',
                                            transform: isSelected ? 'translateY(-1px)' : 'none',
                                        }}
                                        onMouseEnter={(e) => {
                                            if (!isSelected) {
                                                e.currentTarget.style.borderColor = '#cbd5e1';
                                                e.currentTarget.style.background = '#f1f5f9';
                                                e.currentTarget.style.transform = 'translateY(-1px)';
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            if (!isSelected) {
                                                e.currentTarget.style.borderColor = '#e2e8f0';
                                                e.currentTarget.style.background = '#f8fafc';
                                                e.currentTarget.style.transform = 'none';
                                            }
                                        }}
                                    >
                                        <span>{alertType.value.title}</span>
                                        <span style={{
                                            background: isSelected ? '#dc2626' : '#94a3b8',
                                            color: 'white', borderRadius: '8px',
                                            padding: '2px 8px', fontSize: '12px', fontWeight: '700',
                                            minWidth: '24px', textAlign: 'center',
                                        }}>
                                            {alertType.number}
                                        </span>
                                    </button>
                                );
                            })}
                        </div>
                    </Spin>
                </div>

                {/* Alert Cards Grid */}
                <Spin spinning={loading && data.length === 0}>
                    {data.length === 0 && !loading ? (
                        <div style={{
                            background: 'white', borderRadius: '20px', padding: '64px 32px',
                            textAlign: 'center',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.06), 0 4px 12px rgba(0,0,0,0.04)',
                            border: '1px solid rgba(0,0,0,0.04)',
                        }}>
                            <div style={{ fontSize: '56px', marginBottom: '16px', opacity: 0.4 }}>🔔</div>
                            <h3 style={{ color: '#64748b', fontWeight: '600', fontSize: '18px', margin: '0 0 8px' }}>
                                {alertTypes.length === 0 ? 'Chargement des types d\'alertes...' : 'Sélectionnez un type d\'alerte'}
                            </h3>
                            <p style={{ color: '#94a3b8', fontSize: '14px', margin: 0 }}>
                                Cliquez sur une catégorie ci-dessus pour afficher les alertes correspondantes
                            </p>
                        </div>
                    ) : (
                        <>
                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(auto-fill, minmax(360px, 1fr))',
                                gap: '16px',
                                marginBottom: '24px',
                            }}>
                                {data.map((item) => {
                                    const st = getStatus(item.status);
                                    return (
                                        <div key={item.id} style={{
                                            background: 'white', borderRadius: '16px',
                                            border: '1px solid rgba(0,0,0,0.05)',
                                            boxShadow: '0 1px 3px rgba(0,0,0,0.04), 0 4px 12px rgba(0,0,0,0.03)',
                                            overflow: 'hidden',
                                            transition: 'all 0.3s ease',
                                            cursor: 'default',
                                        }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.transform = 'translateY(-3px)';
                                                e.currentTarget.style.boxShadow = '0 8px 30px rgba(0,0,0,0.1)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.transform = 'none';
                                                e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.04), 0 4px 12px rgba(0,0,0,0.03)';
                                            }}
                                        >
                                            {/* Card Top Bar */}
                                            <div style={{
                                                height: '4px',
                                                background: `linear-gradient(90deg, ${st.dot}, ${st.dot}88)`,
                                            }} />

                                            <div style={{ padding: '20px' }}>
                                                {/* Header */}
                                                <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '14px' }}>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: 1 }}>
                                                        <div style={{
                                                            width: '40px', height: '40px', borderRadius: '12px',
                                                            background: '#fef2f2',
                                                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                            fontSize: '18px', flexShrink: 0,
                                                        }}>
                                                            {item.riskType?.icon || <FontAwesomeIcon icon={faExclamationTriangle} style={{ color: '#dc2626' }} />}
                                                        </div>
                                                        <div style={{ minWidth: 0 }}>
                                                            <h3 style={{
                                                                margin: 0, fontSize: '15px', fontWeight: '600',
                                                                color: '#1e293b', lineHeight: '1.4',
                                                                overflow: 'hidden', textOverflow: 'ellipsis',
                                                                display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical',
                                                            }}>
                                                                {item.title}
                                                            </h3>
                                                            <span style={{ fontSize: '12px', color: '#94a3b8', fontWeight: '500' }}>
                                                                {item.riskType?.description}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    {/* Status Badge */}
                                                    <span style={{
                                                        display: 'inline-flex', alignItems: 'center', gap: '6px',
                                                        padding: '4px 10px', borderRadius: '8px',
                                                        background: st.bg, color: st.text,
                                                        fontSize: '11px', fontWeight: '600',
                                                        whiteSpace: 'nowrap', flexShrink: 0,
                                                    }}>
                                                        <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: st.dot }} />
                                                        {st.label}
                                                    </span>
                                                </div>

                                                {/* Description */}
                                                {item.description && (
                                                    <p style={{
                                                        margin: '0 0 14px', fontSize: '13px', color: '#64748b',
                                                        lineHeight: '1.5', overflow: 'hidden', textOverflow: 'ellipsis',
                                                        display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical',
                                                    }}>
                                                        {item.description}
                                                    </p>
                                                )}

                                                {/* Location */}
                                                <div style={{
                                                    display: 'flex', alignItems: 'center', gap: '8px',
                                                    background: '#f8fafc', borderRadius: '10px',
                                                    padding: '10px 12px',
                                                }}>
                                                    <FontAwesomeIcon icon={faMapMarkerAlt} style={{ color: '#dc2626', fontSize: '13px', flexShrink: 0 }} />
                                                    <span style={{ fontSize: '12px', color: '#475569', lineHeight: '1.4' }}>
                                                        <strong>{item.localities?.name}</strong>
                                                        {item.localities?.commune && (
                                                            <span style={{ color: '#94a3b8' }}>
                                                                {' · '}{item.localities.commune.name}, {item.localities.commune.departement?.name}
                                                            </span>
                                                        )}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>

                            {/* Pagination */}
                            {!pageable?.empty && pageable.totalPages > 1 && (
                                <div style={{
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    gap: '12px', padding: '20px',
                                    background: 'white', borderRadius: '16px',
                                    boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                                    border: '1px solid rgba(0,0,0,0.04)',
                                }}>
                                    <button
                                        disabled={pageable?.first}
                                        onClick={() => changePage(pageable?.pageable?.pageNumber - 1)}
                                        style={{
                                            padding: '8px 20px', borderRadius: '10px',
                                            border: '1px solid #e2e8f0', background: 'white',
                                            color: pageable?.first ? '#cbd5e1' : '#475569',
                                            cursor: pageable?.first ? 'not-allowed' : 'pointer',
                                            fontWeight: '600', fontSize: '13px',
                                            transition: 'all 0.2s',
                                        }}
                                    >
                                        ← Précédent
                                    </button>
                                    <span style={{
                                        padding: '8px 16px', borderRadius: '10px',
                                        background: '#f1f5f9', color: '#475569',
                                        fontSize: '13px', fontWeight: '600',
                                    }}>
                                        {(pageable?.pageable?.pageNumber || 0) + 1} / {pageable?.totalPages}
                                    </span>
                                    <button
                                        disabled={pageable?.last}
                                        onClick={() => changePage(pageable?.pageable?.pageNumber + 1)}
                                        style={{
                                            padding: '8px 20px', borderRadius: '10px',
                                            border: '1px solid #e2e8f0', background: 'white',
                                            color: pageable?.last ? '#cbd5e1' : '#475569',
                                            cursor: pageable?.last ? 'not-allowed' : 'pointer',
                                            fontWeight: '600', fontSize: '13px',
                                            transition: 'all 0.2s',
                                        }}
                                    >
                                        Suivant →
                                    </button>
                                </div>
                            )}
                        </>
                    )}
                </Spin>
            </div>
        </div>
    );
}